import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { AddressProfile, CreatedAddressDetails, TrackAddress } from '@rma/addresses/public/domain';
import type { NewAddressDetails } from '@rma/generic/domain/types';
import { RmaUrlsService } from '@rma/generic/util/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AddressesApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaUrls = inject(RmaUrlsService);

  getAddressProfile(addressCode: string): Observable<AddressProfile> {
    const url = this.rmaUrls.apiUrl(`/Addresses/${addressCode}`);
    return this.httpClient.get<AddressProfile>(url);
  }

  createAddress(newAddressDetails: NewAddressDetails): Observable<CreatedAddressDetails> {
    const url = this.rmaUrls.apiUrl('/Addresses');
    return this.httpClient.post<CreatedAddressDetails>(url, newAddressDetails);
  }

  trackAddress(trackAddressDetails: TrackAddress): Observable<void> {
    const url = this.rmaUrls.apiUrl('/Addresses/Track');
    return this.httpClient.post<void>(url, trackAddressDetails);
  }
}
